var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      class: _vm.themeClass,
      style: _vm.backgroundStyle,
    },
    [
      !_vm.errorMessage
        ? [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "remaining" }, [
                _c(
                  "div",
                  { staticClass: "remaining__text", style: _vm.remainingText },
                  [
                    _vm.isInactive ? [_vm._v(_vm._s(_vm.stateText))] : _vm._e(),
                    _vm._v(" "),
                    !_vm.isInactive
                      ? [
                          _c("span", { staticClass: "remaining__label" }, [
                            _vm._v("참여 횟수"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "remaining__number",
                              style: _vm.remainingNumberTextColorStyle,
                            },
                            [_vm._v(_vm._s(_vm.rouletteCount))]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "roulette" }, [
                _c("div", { staticClass: "roulette__pin" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "48",
                        height: "80",
                        viewBox: "0 0 48 80",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M24 0C10.744 0 0 11.622 0 25.9692C0 47.8242 24 80 24 80C24 80 48 47.8242 48 25.9692C48 11.622 37.256 0 24 0Z",
                          fill: _vm.userColorStyle,
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "24",
                          cy: "24",
                          r: "16",
                          fill: _vm.pinStyle,
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    ref: "roulette",
                    staticClass: "roulette__circle",
                    style: _vm.borderColorStyle,
                    on: {
                      transitionend: function ($event) {
                        return _vm.showPopup(1)
                      },
                    },
                  },
                  _vm._l(_vm.coupons, function (coupon, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        staticClass: "roulette__slice",
                        style: "" + _vm.getBackgroundColor(key),
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "roulette__label",
                            style: _vm.labelTextColorStyle,
                          },
                          [_vm._v(_vm._s(_vm.displayLabel(coupon))), _c("br")]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "roulette__spin-button spin-button",
                    attrs: { disabled: _vm.isDisabled },
                    on: { click: _vm.onSpin },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "spin-button__container",
                        style: _vm.spinBtnOuterShadowStyle,
                      },
                      [
                        _c("div", { staticClass: "spin-button__outer" }, [
                          _c(
                            "div",
                            {
                              staticClass: "spin-button__inner",
                              style: _vm.spinBtnInnerStyle,
                            },
                            [
                              _c("div", {
                                staticClass: "spin-button__background",
                                style: _vm.spinBtnInnerShadowStyle,
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "spin-button__label",
                                  style: _vm.orderTxtColorStyle,
                                },
                                [_vm._v(_vm._s(_vm.orderTxt))]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  "font-size": "5rem",
                  color: "red",
                  "text-align": "center",
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("popup", {
        attrs: {
          visible: _vm.settingsPopup.visible,
          type: _vm.settingsPopup.type,
          title: _vm.settingsPopup.title,
          subtitle: _vm.settingsPopup.subtitle,
          buttonText: "확인",
        },
        on: { close: _vm.callback },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }